import dynamic from 'next/dynamic';
import { useTranslation } from 'react-i18next';
import { $generateHtmlFromNodes } from '@lexical/html';
import { $getRoot } from 'lexical';
import { CharCount, EditorShell } from './styles';

/**
 * 의견 입력기 — BoardEditor(isSimple) 패턴. 글자수는 plain text 길이 정보용(상한 강제 없음).
 * MUI Modal 닫힐 때 언마운트돼 재오픈 시 빈 에디터로 새로 마운트.
 */

// BoardEditor 는 SSR 비대응 → dynamic import (MessageEditor / RHFLexicalEditor 와 동일).
const LexicalBoardEditor = dynamic(
  () => import('@/components/LexicalEditor/BoardEditor'),
  { ssr: false },
);

type OpinionEditorProps = {
  onChange: (html: string, length: number) => void;
  length: number;
};

const OpinionEditor = ({ onChange, length }: OpinionEditorProps) => {
  const { t } = useTranslation();

  return (
    <EditorShell>
      <LexicalBoardEditor
        isSimple
        defaultFontSize={16}
        value=""
        placeholder={t('의견을 입력해 주세요.')}
        onChange={(_editorState, editor) => {
          editor.update(() => {
            const html = $generateHtmlFromNodes(editor, null);
            const textLength = $getRoot().getTextContent().length;
            onChange(html, textLength);
          });
        }}
      />
      <CharCount>{length.toLocaleString()}</CharCount>
    </EditorShell>
  );
};

export default OpinionEditor;
